// Filename helper for the `media` bucket.
//
// The *folder* (org/project/province/date/location/feature) is now resolved
// server-side by the `get_media_folder` RPC — the single source of truth — via
// `useMediaFolder` / the upload repository. This class only appends a unique
// filename to a folder the caller already has.

export class UploadPath {
  /** Generate a unique filename, preserving the original extension. */
  static fileName(originalName: string, prefix = 'upload'): string {
    const ext = originalName.includes('.') ? originalName.split('.').pop()! : 'jpg';
    return `${prefix}_${Date.now()}.${ext.toLowerCase()}`;
  }

  /** Append a generated filename to a server-resolved folder. */
  static buildFilePath(folderPath: string, originalName: string, prefix = 'upload'): string {
    const cleanFolder = folderPath.replace(/\/$/, '');
    return `${cleanFolder}/${UploadPath.fileName(originalName, prefix)}`;
  }
}
